import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import 'dayjs/locale/uk'
import 'dayjs/locale/en'
import { Component } from 'preact'
import 'preact-material-components/Button/style.css'
import 'preact-material-components/Elevation/style.css'
import 'preact-material-components/LayoutGrid/style.css'
import 'preact-material-components/LinearProgress/style.css'
import 'preact-material-components/Select/style.css'
import 'preact-material-components/TextField/style.css'
import 'preact-material-components/Typography/style.css'
import { connect, Provider } from 'preact-redux'
import store from '../../store'
import CustomerInfoLayout from '../CustomerInfoLayout'
import OrderSuccess from '../OrderSuccess'
import RoomsLayout from '../RoomsLayout'
import styles from './App.scss'
import i18n from '../../i18n'

const searchParams = new URLSearchParams(window.location)
let searchlist = null
for (let p of searchParams) {
    if (p[0] === 'search') {
        searchlist = p[1]
    }
}
if (!!searchlist) {
    searchlist = searchlist.replace('?', '')
    let listAsObject = {}
    searchlist.split('&').map(item => {
        const splititem = item.split('=')
        listAsObject[splititem[0]] = splititem[1]
    })
    if (listAsObject.lang) {
        i18n.changeLanguage(listAsObject.lang)
    }
}

dayjs.locale(i18n.language)

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeStep: 0,
            arrivalUseAlready: false,
            departureUseAlready: false,
            startDateDefault: null,
            endDateDefault: null
        }

        this.changeUseDateInfo = this.changeUseDateInfo.bind(this)
    }

    handleBackToStart = () => this.setState({ activeStep: 0 })
    handleGoToUserClick = () => this.setState({ activeStep: 1 })
    handleOrderSuccess = () => this.setState({ activeStep: 2 })

    chLang = lang => {
        i18n.changeLanguage(lang)
        dayjs.locale(lang)
    }

    changeUseDateInfo(type, date, notUseState) {
        if (type === 'arrival') {
            if (!notUseState) {
                this.setState({
                    arrivalUseAlready: true,
                    startDateDefault: date
                })
            } else {
                this.setState({
                    startDateDefault: date
                })
            }
        }
        if (type === 'departure') {
            if (!notUseState) {
                this.setState({
                    departureUseAlready: true,
                    endDateDefault: date
                })
            } else {
                this.setState({
                    endDateDefault: date
                })
            }
        }
    }

    render({ moduleKey }) {
        const { activeStep } = this.state

        return (
            <Provider store={store}>
                <div class={styles.App}>
                    {activeStep === 0 && (
                        <RoomsLayout
                            secretKey={moduleKey}
                            onGoNext={this.handleGoToUserClick}
                            activeStep={activeStep}
                            arrivalUseAlready={this.state.arrivalUseAlready}
                            departureUseAlready={this.state.departureUseAlready}
                            changeUseDateInfo={this.changeUseDateInfo}
                            startDateDefault={this.state.startDateDefault}
                            endDateDefault={this.state.endDateDefault}
                        />
                    )}
                    {activeStep === 1 && (
                        <CustomerInfoLayout onGoNext={this.handleOrderSuccess} onNewSearch={this.handleBackToStart} />
                    )}
                    {activeStep === 2 && <OrderSuccess onBackToStart={this.handleBackToStart} />}
                </div>
            </Provider>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./components/App/App.js